<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <!-- <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div> -->
            <!-- <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.groupService') }}</div>
                <select-with-search-table
                  style="width: 100%"
                  index-field="id"
                  :search-fields="['code', 'desc']"
                  :selected-index-field-value="searchParams.groupService"
                  :rows="groupServiceOptions"
                  :columns="groupServiceOptionsCols"
                  :value="searchParams.bookingGroup"
                  :dropdown-width="400"
                  :is-remove-btn="true"
                  @selectionChanged="onSelectBookingGroup"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <div>
                      <span v-if="selectedData?.code && selectedData?.desc">
                        {{ selectedData.code }} -
                        {{ selectedData.desc }}
                      </span>
                    </div>
                  </template>
                </select-with-search-table>
              </div>
            </div> -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIds"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder="Chọn khách sạn"
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Lễ tân</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.accountId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in receptionistOptions"
                      :key="index"
                      :value="item.account.id"
                      :label="`(${item.account.username}) ${item.account.full_name}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <!-- <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  mode="date"
                  @input="onChangeDateFrom"
                /> -->
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    :disabled="disabledDate"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <input v-model="searchParams.recode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số hóa đơn' }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.invoiceCode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.product') }}</div>
                <el-select
                  v-model="searchParams.productId"
                  collapse-tags
                  filterable
                  clearable
                  placeholder="Chọn sản phầm"
                >
                  <el-option
                    v-for="item in productOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <!-- <div class="laundry-report__wrapper"> -->
    <div class="content-box report-grid-container">
      <div class="section-box outline">
        <div class="das-form-container" style="flex: 1">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"> Báo cáo giặt là </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />
          <!-- <div class="das-form-title-container mt-20">
              <div class="das-form-title">
                <span class="sub-title"> Giặt là </span>
              </div>
            </div> -->

          <div v-loading="loading" class="collapse-grid__list">
            <p
              v-if="laundryDataList.length == 0"
              style="text-align: center; margin-top: 100px"
            >
              Không có dữ liệu
            </p>
            <el-collapse v-model="collapseNameList">
              <div
                v-for="laundryData in laundryDataList"
                :key="laundryData.hotel_id"
                class="collapse-grid__item"
              >
                <el-collapse-item :name="laundryData.hotel_id">
                  <template slot="title">
                    <span class="collapse-grid__item-header">
                      {{ 'Khách sạn:' }} {{ laundryData.hotel_name }}
                    </span>
                  </template>
                  <div class="grid-scroll" style="height: 400px">
                    <GridVx
                      ref="agGrid"
                      :columns="columns"
                      :rows="laundryData.rows"
                      :is-row-selectable="isRowSelectable"
                      :default-col-def="defaultColDef"
                      class="agGrid collapse-grid__agGrid"
                      dom-layout="scroll"
                      :auto-size-cell="true"
                      :full-width-cell-renderer="fullWidthCellRenderer"
                      :embed-full-width-rows="true"
                    />
                    <!-- :pinned-bottom-row-data="pinnedBottomRowData" -->
                  </div>
                </el-collapse-item>

                <div class="collapse-grid__item-footer">
                  {{ 'Tổng' }}: {{ $displayCurrency(laundryData.total) }}
                </div>
              </div>
            </el-collapse>
          </div>

          <hr style="margin-top: 14px" />
          <div class="total-price">
            <span> Tổng: {{ $displayCurrency(totalAmount) }} </span>
            <span style="padding-left: 20px">
              {{ 'Số lượng' }}:
              {{ $displayCurrency(totalQuantity) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <h3></h3>
          <div class="note-container">
            <h3 class="note-title">Hiển thị tham số</h3>
            <ul>
              <!-- <li>
                Minibar : Dịch vụ Minibar, hiển thị theo danh sách các loại dịch
                vụ phát sinh dữ liệu
              </li> -->
              <li>Số hóa đơn</li>
              <li>Ngày hóa đơn: Ngày tạo hóa đơn</li>
              <li>Mã giá: Mã giá áp dụng cho phòng</li>
              <li>
                Mã đặt phòng: mã đặt phòng phát sinh giao dịch với dịch vụ
              </li>
              <li>Nhân viên tạo: hóa đơn</li>
              <li>Tổng cộng: tổng số tiền của hóa đơn</li>
            </ul>
            <h3 class="note-title">Bảng dữ liệu</h3>
            <ul>
              <li>Mã sản phẩm: Hiển thị mã sản phẩm</li>
              <li>Tên: Hiển thị tên mặt hàng</li>
              <li>Đơn giá: Hiển thị giá đơn vị của dịch vụ</li>
              <li>
                Số lượng: Hiển thị số lượng sản phẩm được sử dụng theo bill
              </li>
              <li>Thành tiền: Hiển thị thành tiền = giá đơn vị * số lượng</li>
              <li>Giảm giá: Hiển thị giảm giá dịch vụ theo giá tổng tiền</li>
              <li>Bao gồm thuế, phí: Hóa đơn đã bao gồm thuế, phí</li>
              <li>
                Tổng tiền giảm giá: tổng số tiền được giảm giá trong tổng tiền
              </li>
              <li>
                Tổng tiền hóa đơn: bằng tổng tiền - tổng tiền giảm giá ( với Phí
                dịch vụ mặc định được quy định theo số tiền , và thuế theo số
                tiền)
              </li>
              <li>Tổng tiền Mini bar ...: tổng tiền của từng loại dịch vụ</li>
              <li>
                Tổng: tổng tiền của tất cả các loại dịch vụ phát sinh giao dịch
              </li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
// import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import FullWidthCellTransaction from '../components/FullWidthCellTransaction.vue'
import InfoBtn from '../components/InfoBtn.vue'
import LaundryPieChartReport from './components/LaundryPieChartReport.vue'
import { getAllHotel } from '@/api/hotel.js'
import {
  getListMinibarReport,
  getListMinibarReportExcel,
  getReceptionestOptions,
  getProductLaundryOptions
} from '@/api/report_service/miniBarReport'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import moment from 'moment'

const getDefaultSearchParams = () => ({
  dateFrom: moment().format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
  hotelIds: [],
  recode: null,
  code: null,
  accountId: null,
  productId: null,
  invoiceCode: null
})

export default {
  components: {
    DasButton,
    // CalendarSelect,
    CalendarRange,
    // eslint-disable-next-line vue/no-unused-components
    InfoBtn,
    // eslint-disable-next-line vue/no-unused-components
    FullWidthCellTransaction,
    // eslint-disable-next-line vue/no-unused-components
    LaundryPieChartReport
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      disabledDate: false,
      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      hotelOptions: [],
      groupServiceOptions: [],
      receptionistOptions: [],
      productOptions: [],
      columns: [
        {
          headerName: this.$t('grid.column.productCode'),
          field: 'product_code',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.productName'),
          field: 'product_name',
          // cellClass: "grid-cell-centered",
          // width: 100,
          flex: 1,
          sortable: false,
          minWidth: 200
        },
        {
          headerName: this.$t('grid.column.priceUnit'),
          field: 'unit',
          cellRenderer: params => this.$displayCurrency(params.value),
          tooltipValueGetter: params => this.$displayCurrency(params.value),
          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.quantity'),
          field: 'quantity',
          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.discount'),
          field: 'discount',
          cellRenderer: params => this.$displayCurrency(params.value),
          tooltipValueGetter: params => this.$displayCurrency(params.value),
          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.totalAmount'),
          field: 'price',
          cellRenderer: params => this.$displayCurrency(params.value),
          tooltipValueGetter: params => this.$displayCurrency(params.value),
          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 200,
          sortable: false
        }
      ],
      rows: [],
      pinnedBottomRowData: [
        {
          col1: '335,000',
          isPinnedBottom: true
        }
      ],
      isRowSelectable: node => !node.data.isFullWidthRow,
      laundryDataList: [],
      collapseNameList: [],
      totalAmount: 0,
      totalQuantity: 0,

      loading: false,
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      }
    }
  },
  watch: {
    recode: {
      handler(val) {
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },
  beforeMount() {
    // GRID
    this.fullWidthCellRenderer = 'FullWidthCellTransaction'
  },
  mounted() {
    this.getHotelOptions()
    this.attachData()
    this.fnGetProductOptions()
    this.getReceptionestList()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    // SELECT OPTIONS
    getHotelOptions() {
      getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },
    async fnGetProductOptions() {
      const data = await getProductLaundryOptions()
      this.productOptions = data.data || []
    },
    async getReceptionestList() {
      const data = await getReceptionestOptions()
      this.receptionistOptions = data.data || []
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = getDefaultSearchParams()
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    },
    onClickDropdownItem(cmd) {
      // this.$message('click on item ' + cmd)
      if (cmd === 'excel') {
        const queryParams = {
          ...this.searchParams,
          code: 'Laundry'
        }
        getListMinibarReportExcel(queryParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'laundry_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },

    transferDataList(dataList) {
      const transferedDataList = []

      this.totalAmount = 0
      dataList.forEach(dataItem => {
        // Get FLAT array
        const dataRows = dataItem.data.flatMap(item => {
          const dataItemTop = item.top
          const dataItemBot = item.bot

          const firstRow = {
            isFullWidthRow: true,
            billNumber: dataItemTop.invoice_num,
            billDate: dataItemTop.create_date,
            bookingCode: dataItemTop.recode,
            totalDiscount: dataItemBot.total_discount,
            createdBy: dataItemTop.staff,
            roomNum: dataItemTop.room_num,
            total: dataItemTop.total,
            totalBill: dataItemBot.total_money
          }

          // const secondRow = {
          //   isFullWidthRow: true,
          //   totalBill: dataItemBot.total_money,
          //   totalDiscount: dataItemBot.total_discount,
          //   includeTaxFee: dataItemBot.include_tax_fee,
          //   billNum: dataItemTop.invoice_num,
          //   serviceFee: dataItemBot.fee,
          //   taxFee: dataItemBot.tax
          // }

          return [firstRow, ...item.product]
        })

        const transferedData = {
          hotel_id: dataItem.hotel_id,
          hotel_name: dataItem.hotel_name,
          total: dataItem.total,
          rows: dataRows
        }

        this.totalAmount += dataItem.total

        transferedDataList.push(transferedData)

        // For Showing all item
        // this.collapseNameList.push(dataItem.hotel_id)
      })

      return transferedDataList
    },

    attachData() {
      const queryParams = {
        ...this.searchParams,
        code: 'Laundry'
      }
      this.loading = true

      getListMinibarReport(queryParams)
        .then(res => {
          this.laundryDataList = this.transferDataList(res.data)
          this.totalQuantity = res.number
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.agGrid {
  .ag-full-width-row {
    background-color: #fff !important;
  }
}

.total-price {
  font-weight: 600;
  text-align: right;
}

// .col-span-2 {
//   grid-column: span 2 / span 2;
// }

// .laundry-report__wrapper {
//   display: grid;
//   grid-template-columns: repeat(1, minmax(0, 1fr));
//   gap: 10px;
//   // flex-wrap: wrap;
//   // flex-direction: column;

//   .laundry-report__table-wrapper {
//     grid-column: 1 / span 1;
//   }

//   .content-box {
//     min-height: 600px;
//   }
// }

// @media only screen and (min-width: 1280px) {
//   .laundry-report__wrapper {
//     grid-template-columns: repeat(2, (minmax(0, 1fr)));

//     .laundry-report__table-wrapper {
//       grid-column: 1 / span 2;
//     }
//   }
// }
</style>

<style lang="scss">
.report-grid-container {
  --cell-border-color: rgba(189, 195, 199, 0.5);
  --ag-header-bg: #5f8b76;

  height: 100%;

  .collapse-grid__list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    // overflow-y: auto;

    .el-collapse {
      border: 0 !important;
    }
  }

  .collapse-grid__item {
    .el-collapse-item__header {
      background-color: #357456;
      color: #fff !important;
      border-bottom: 1px solid var(--cell-border-color);
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    &-header {
      font-weight: 600;
      flex: 1;
      font-size: 14px;
      padding: 0 12px;
    }

    &-footer {
      height: 34px;
      line-height: 34px;
      padding: 0 12px;
      background-color: #e7f6e5 !important;
      border-bottom: 1px solid var(--cell-border);
      margin-bottom: 2px;
      font-weight: 500;
      font-size: 14px;
    }

    .grid-scroll {
      // height: 400px;
      // max-height: 400px;
    }

    .agGrid.collapse-grid__agGrid {
      .ag-header-viewport {
        background-color: var(--ag-header-bg) !important;
      }

      .header-row,
      .header-row:hover {
        background-color: var(--ag-header-bg) !important;
        color: white;
        font-weight: bold;
      }

      .ag-header-row-column {
        background-color: var(--ag-header-bg) !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.content-container .content-box .section-box.outline {
  height: auto !important;
  min-height: 100%;
}
</style>
